import { exportBudgetExecute, exportProjectExecute } from '../services';

export default {
  namespace: 'performTable',
  state: {},
  effects: {
    // 导出预算支出明细执行情况表
    *exportBudgetExecute({ payload }, { call }) {
      return yield call(exportBudgetExecute, payload);
    },

    // 导出项目执行情况表
    *exportProjectExecute({ payload }, { call }) {
      return yield call(exportProjectExecute, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
